import React, { useMemo } from 'react';
import { Popover, PopoverTrigger, PopoverSurface, Text } from '@fluentui/react-components';

import { ICoupon } from '../types';

export const CouponFlag = ({ coupon, i18n, rightAlign } : {
  coupon: ICoupon;
  i18n: {
    getString: (key: string, data?: object) => string;
  };
  rightAlign: boolean;
}) => {
  const trigger = useMemo(() => (
    <div className={rightAlign ? 'coupon-right-aligned' : ''}>
      <span className="coupon-tag">
        <span className="coupon-tag-main-triangle" />
        <span className="coupon-tag-message">
          <span className="tag-message-content">
            {i18n.getString(_TL_('{{value}} offer'), { value: coupon.value.toString() })}
          </span>
        </span>
      </span>
    </div>
  ), [coupon.value, i18n, rightAlign]);

  const flyout = useMemo(() => (
    <div className="coupon-tag-flyout">
      <div className="coupon-tag-flyout-content">
        <Text className="coupon-tag-flyout-line1">
          {i18n.getString(_TL_('Get {{value}} when you {{tagMessage}}.'), coupon)}
        </Text>
        <Text className="coupon-tag-flyout-line2">
          {i18n.getString(_TL_('This is a limited-time offer. Please act soon!'))}
        </Text>
      </div>
    </div>
  ), [coupon, i18n]);

  return (
    <Popover withArrow openOnHover size="small">
      <PopoverTrigger disableButtonEnhancement>
        {trigger}
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        {flyout}
      </PopoverSurface>
    </Popover>
  );
};
